<template>
  <div class="h-auto ml-0 w-full m-sidebarWidth lg:mr-3">
    <div class="bg-white mx-3 mt-3 rounded-t-md border-b-0.5">
      <div class="flex justify-between items-center p-3">
        <p class="font-semibold lg:text-base text-sm">
          Company Claim Management
        </p>
      </div>
    </div>

    <div
      class="flex flex-wrap justify-between lg:divide-x-1.5 bg-gray-50 mx-3 mb- items-center border-0.5"
    >
      <router-link
        :to="{ name: 'claim-setups', params: { type: menu.route } }"
        v-for="(menu, index) in subMenus"
        :key="index"
        :class="{
          'bg-primary text-white': selectedSubMenu == menu.name,
        }"
        class="text-sm text-center hover:bg-primary hover:text-white cursor-pointer lg:p-3 p-2 flex-grow"
      >
        {{ menu.name }}
      </router-link>
    </div>

    <LeaveTypeList
      :key="tTKey"
      v-if="selectedSubMenu == 'Claim Types'"
    ></LeaveTypeList>

    <LeaveWorkflow
      :key="tWKey"
      v-if="selectedSubMenu == 'Claim Workflows'"
    ></LeaveWorkflow>

    <TimeOffJournalsList
      :key="tJKey"
      v-if="selectedSubMenu == 'Claim Journals'"
    ></TimeOffJournalsList>
    <TimeOffLedgerList
      :key="tJKey"
      v-if="selectedSubMenu == 'Claim Ledgers'"
    ></TimeOffLedgerList>
  </div>
</template>

<script>
import LeaveTypeList from "@/components/CompanySetups/leaveTypes/leaveTypeList.vue";
import LeaveWorkflow from "@/components/CompanySetups/leaveWorkflow/LeaveWorkflow.vue";
import TimeOffJournalsList from "@/components/CompanySetups/timeOffSetups/timeOffJournalsList.vue";
import TimeOffLedgerList from "@/components/CompanySetups/timeOffSetups/timeOffLedgerEntriesList.vue";

export default {
  name: "CompanyClaimSetups",
  components: {
    LeaveTypeList,
    LeaveWorkflow,

    TimeOffJournalsList,
    TimeOffLedgerList,
  },
  data() {
    return {
      tTKey: 0,
      tWKey: 1,
      tPKey: 2,
      tJKey: 3,
      tLKey: 4,

      selectedSubMenu: "Claim Types",
      subMenus: [
        {
          name: "Claim Types",
          route: "claim-types",
        },
        { name: "Claim Workflows", route: "claim-workflows" },

        { name: "Claim Journals", route: "claim-journals" },
        { name: "Claim Ledgers", route: "claim-ledgers" },
      ],
    };
  },
  watch: {
    $route(to) {
      this.subMenus.forEach((menu) => {
        if (menu.route == to.params.type) {
          this.selectedSubMenu = menu.name;
        }
      });
      switch (this.selectedSubMenu) {
        case "Claim Types":
          this.tTKey++;
          break;
        case "Claim Workflows":
          this.tWKey++;
          break;
        case "Claim Periods":
          this.tPKey++;
          break;
        case "Claim Journals":
          this.tJKey++;
          break;
        case "Claim Ledgers":
          this.tLKey++;
          break;
        case "Base Calendar":
          this.bCKey++;
          break;
      }
    },
  },
};
</script>
